<div
    class="visit"
    [ngStyle]="{ cursor: visit.has_semd ? 'pointer' : 'auto' }"
    (click)="goPreview(visit.keyid, visit.typehistory, $event)"
>
    <div class="visit__date">
        <!-- <span>&#10036;</span> -->
        {{ getTekDay(visit.dtSort) }} в {{ getTime(visit.dtSort) }}
        <div style="color: #435b78; font-weight: 400">
            {{ getNameDay(visit.dtSort) }}
        </div>
    </div>
    <div class="visit__doctor">
        {{ visit.spec }} <br />
        <span class="name-capitalize">{{ visit.doctor }}</span>
    </div>
    <div class="visit__questions">
        <span> Исследование:</span>
        <span> Филиал:</span>
        <span> Отделение:</span>
    </div>
    <div class="visit__answers">
        <span> {{ visit.typetext }}</span>
        <span> {{ visit.dep_name }}</span>
        <span> {{ visit.dep_root_name }}</span>
    </div>
    <div class="visit__record">
        <div class="visit__record-wrapper">
            <span>Повторная запись:</span>
            <ng-container
                *ngIf="
                    visit.sched_exists_for_dd_on_visit == 1;
                    then online;
                    else offline
                "
            >
            </ng-container>
            <ng-template #online>
                <ng-template #tipContentOnline let-greeting="greeting"
                    >Записаться на прием.</ng-template
                >
                <p
                    class="cls-label-OnLine"
                    routerLink="/home/rec"
                    placement="left"
                    [ngbTooltip]="tipContentOnline"
                    tooltipClass="tooltipPanel"
                >
                    Онлайн
                </p>
            </ng-template>
            <ng-template #offline
                ><span [ngbTooltip]="tipContentOffline">В регистратуре</span>
                <ng-template #tipContentOffline let-greeting="greeting">
                    <mat-icon
                        svgIcon="phone-notColor"
                        style="height: 14px"
                    ></mat-icon>
                    <span
                        [innerHTML]="txtPhone"
                        class="txtPhone"
                    ></span> </ng-template
            ></ng-template>

            <div class="visit__result">
                <!-- *ngIf="visit.cnt_prot !== 0" -->
                <button
                    class="result-item"
                    *ngIf="visit.has_semd !== 0"
                    (click)="
                        gotToDownload(visit.keyid, visit.typehistory, $event)
                    "
                >
                    <img
                        *ngIf="!pdfLoading"
                        class="result-item__img"
                        [src]="pdfImageURL"
                    />
                    <img
                        *ngIf="pdfLoading"
                        class="loader-rotate"
                        src="./assets/img/svg/loader-btn.svg"
                    />
                </button>
                <ng-container
                    *ngIf="visit.accession_no; then dicom"
                ></ng-container>
                <ng-template #dicom>
                    <button
                        class="result-item"
                        (click)="
                            openDicomModal(
                                visit.accession_no,
                                visit.study_date,
                                visit.study_iuid,
                                $event
                            )
                        "
                    >
                        <img
                            class="result-item__img"
                            src="./assets/img/svg/dicom-view.svg"
                        />
                    </button>
                    <a
                        class="result-item"
                        href="{{ getDownloadUrl(visit.study_iuid) }}"
                        (click)="stopPropagation($event)"
                        download="sos"
                        ><img
                            class="result-item__img"
                            src="./assets/img/svg/dicom-download.svg"
                    /></a>
                </ng-template>
            </div>
        </div>
    </div>
</div>
